import * as types from './types'
export default {
  globalNum () {
    return types.oUrl
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js